export interface QueryTag {
    id: string,
    key: string,
    value: string
}

export interface AuditAPIData {
    conditions?: QueryTag[],
    limit?: number,
    startDate?: string,
    endDate?: string,
    sort?: SortOrder
}

export enum SortOrder {
    ASC = 'ascending',
    DESC = 'descending'
}
export interface AuditResponseData {
    actor_id: string,
    actor_name: string,
    created_at: string,
    id: string,
    operation: string,
    org_id: string,
    props: any,
    resource_id: string,
    resource_name: string,
    text_payload: string,
}

export enum DateMode {
    ALL = 'all',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
    NONE = 'none'
}

export interface AuditParams {
    orgId?: string
}